import { render, staticRenderFns } from "./SetPeople.vue?vue&type=template&id=86b7aa9a&scoped=true&"
import script from "./SetPeople.vue?vue&type=script&lang=js&"
export * from "./SetPeople.vue?vue&type=script&lang=js&"
import style0 from "./SetPeople.vue?vue&type=style&index=0&id=86b7aa9a&scoped=true&lang=css&"
import style1 from "./SetPeople.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b7aa9a",
  null
  
)

export default component.exports